<template>
    <form-field v-bind="fieldProps">
        <phone-input
            v-bind="inputProps"
            :countryCodePath="countryCodePath"
            @change="change($event)"
            @emitEvent="emitEvent($event, ['change'])"
        ></phone-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'
    import FormPrefillingMixin from 'mixins/FormPrefillingMixin'

    export default {
        mixins: [FormFieldMixin, FormPrefillingMixin],

        props: {
            placeholder: { type: String, default: undefined },
            isSuggested: { type: Boolean, default: false },
        },

        computed: {
            countryCodePath() {
                return `${this.valuePath}CountryCode`
            },
        },
    }
</script>
